import { SCORE_BANDS, THREATS, } from './scoring.js';
/**
 * The insurer's portfolio (tracker task 29): every assessment the person can see, with the latest stored
 * score summarised for underwriting, and totals across them. Read-only; decisions come later.
 */
export const ASSESSMENT_STATUSES = [
    'in_progress',
    'submitted',
    'in_review',
    'in_remediation',
    'decided',
    'closed',
];
export function portfolioScore(stored, meta) {
    return {
        seq: meta.seq,
        score: stored.score,
        band: stored.band,
        provisional: stored.provisional,
        cap: stored.kill_switches.cap,
        exceptions: [...stored.kill_switches.failed].sort((a, b) => a.cap - b.cap || (a.control < b.control ? -1 : 1)),
        pending_kill_switches: stored.kill_switches.pending.length,
        evidence_confidence: stored.controls.evidence_confidence,
        resilience: stored.resilience,
        expected_annual_loss: stored.expected_annual_loss,
        scored_at: meta.scored_at,
        change_30d: meta.scores > 1 && meta.baseline !== null ? stored.score - meta.baseline : null,
    };
}
export function portfolioSummary(rows) {
    const scored = rows.flatMap((r) => (r.score ? [r.score] : []));
    const mean = (ns) => (ns.length ? ns.reduce((a, b) => a + b, 0) / ns.length : null);
    const avg = mean(scored.map((s) => s.score));
    const losses = scored.flatMap((s) => (s.expected_annual_loss === null ? [] : [s.expected_annual_loss]));
    return {
        assessments: rows.length,
        scored: scored.length,
        average_score: avg === null ? null : Math.round(avg),
        average_evidence: mean(scored.map((s) => s.evidence_confidence)),
        exceptions: scored.reduce((n, s) => n + s.exceptions.length, 0),
        with_exceptions: scored.filter((s) => s.exceptions.length).length,
        provisional: scored.filter((s) => s.provisional).length,
        expected_annual_loss: losses.reduce((a, b) => a + b, 0),
        loss_modelled: losses.length,
        bands: Object.fromEntries(SCORE_BANDS.map((b) => [b.key, scored.filter((s) => s.band === b.key).length])),
        status: Object.fromEntries(ASSESSMENT_STATUSES.map((st) => [st, rows.filter((r) => r.status === st).length])),
    };
}
/** The scenarios an underwriter scans first, in the order the portfolio shows them. */
export const PORTFOLIO_THREATS = ['ransomware', 'bec'];
export const threatName = (t) => THREATS[t].name;
export const MEASURE_WINDOWS = [7, 30, 90];
//# sourceMappingURL=portfolio.js.map